import { createI18n } from 'vue-i18n';
import { DEFAULT_LOCALE, messages, resolveInitialLocale } from '@/plugins/i18n';

export function createI18nInstance(initialLocale?: string | null) {
  const locale = resolveInitialLocale(initialLocale);

  const i18n = createI18n({
    legacy: false,
    locale,
    fallbackLocale: DEFAULT_LOCALE,
    messages,
    globalInjection: true,
  });

  return { i18n, locale };
}
